/**
 * 許可IP
 */
import Vue from "vue";
import * as types from "../../mutation-types/backyard-types";
import * as httpConst from "../../../constants/httpConst";

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/allow_ipmasks`

const allow_ipmask = {
    namespaced: true,
    state: {
        allow_ipmasks: [],
        pagination: {
            current_page: 1,
            total_count: 0
        },
    },
    getters: {
        isAllowIpmask: ( state ) => {
            return (state.pagination.total_count > 0)
        },
    },
    actions: {
        fetchAll({ commit, state },{page}) {
            const params = { page: page }
            return new Promise((resolve, _reject) => {
                Vue.$http.get(API_PATH,{ params: params }).then(data => {
                    let content = data.content
                    commit(types.BACK_ALLOW_IPMASK, { content })
                })
            })
        },
        show ({ commit, state }, {id}) {
            const api_path = `${API_PATH}/${id}`
            return new Promise((resolve, _reject) => {
                Vue.$http.get(api_path).then(data => {
                    let content = data.content
                    resolve(content)
                })
            })
        },
        new ({ _commit }) {
            const api_path = `${API_PATH}/new`
            return new Promise((resolve, _reject) => {
                Vue.$http.get(api_path).then(data => {
                    let content = data.content
                    resolve(content)
                })
            })
        },
        edit({ _commit, state }, { id }) {
            const api_path = `${API_PATH}/${id}/edit`
            return new Promise((resolve, _reject) => {
                Vue.$http.get(api_path).then(data => {
                    let content = data.content
                    resolve(content)
                })
            })
        },
        create( { commit, state }, { params } ) {
            return new Promise( ( resolve, _reject) => {
                Vue.$http.post(API_PATH, params).then( data => {
                    commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
                    let content = data.content
                    commit(types.BACK_ALLOW_IPMASK_ITEM_ADD, { content })
                    resolve(content)
                } )
            })
        },
        update( {commit, state}, { id, params } ) {

            const oldContent = state.allow_ipmasks.find((o) => {
                return o.id === id;
            });

            const api_path = `${API_PATH}/${id}`
            return new Promise( ( resolve, _reject) => {
                Vue.$http.patch(api_path, params).then( data => {
                    commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
                    let content = data.content
                    commit(types.BACK_ALLOW_IPMASK_ITEM_UPDATE, { oldContent, content })
                    resolve(content)
                } )
            })
        },
        destroy( { commit, state }, { id } ) {

            const remove_id = id

            const api_path = `${API_PATH}/${id}`
            return new Promise( ( resolve, _reject ) => {
                Vue.$http.delete(api_path).then(data => {
                    commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
                    let content = data.content
                    commit(types.BACK_ALLOW_IPMASK_ITEM_DELETE, { remove_id })
                    resolve(content)
                })
            })
        },
    },
    mutations: {
        [types.BACK_ALLOW_IPMASK] (state, { content }) {
            state.pagination = content.pagination
            state.allow_ipmasks = content.allow_ipmasks
        },
        [types.BACK_ALLOW_IPMASK_ITEM_ADD] (state, { content }) {
            state.allow_ipmasks.push(content)
        },
        [types.BACK_ALLOW_IPMASK_ITEM_UPDATE] (state, { oldContent, content }) {
            Object.assign(oldContent, content);
        },
        [types.BACK_ALLOW_IPMASK_ITEM_DELETE] (state,  { remove_id }) {
            state.allow_ipmasks = state.allow_ipmasks.filter( o => o.id !== remove_id )
        }
    },
}

export default allow_ipmask